export default `p = abs(p)-s;
  return length(max(p, 0.))+min(max(p.x, max(p.y, p.z)), 0.);
}
float de(vec3 p) {
    float t = time;
    float box = sdBox(p, vec3(1.0));
    float scale = 5.5;
    float surf = cos(p.x * scale) + cos(p.y * scale) + cos(p.z * scale) + 2. * sin(t);
    surf = abs(surf) - 0.01;
    surf *= 0.1;
    return max(box, surf);
}`